export const organization = {
  assignedVehicle: "下属设备",
  assignedDriver: "下属操作员",
  viewDetail: "查看详情",
  account: "账号",
  role: "角色",
  contactInformation: "联系方式",
  feetSetting: "车间设定",
  feetManager: "车间管理员",
  addNextNode: "新建下级部门",
  parentDepartment: "隶属部门",
  departmentName: "部门名称",
  pleaseSelectParentDepartment: "请选择隶属部门",
  pleaseInputDepartmentName: "请输入部门名称",
  departmentAddress: "地址",
  departmentManager: "管理员",
  editCurrentNode: "编辑部门",
  addNextFleet: "新建车间",
  editFleet: "编辑车间",
  fleetDelete: "删除车间",
  deleteOrganizationNode: "删除部门",
  deleteOrganizationNodeTip:
    "部门【{departmentName}】不能删除。\n请先移除管理员、下级部门、车间和司机后重试。",
  permanentlyDelete: "警告：永久删除",
  permanentlyDeleteTip:
    "将要删除 【{departmentName}】，删除后不能恢复。\n请确认是否继续。",
  deleteFailedDepartmentNotEmpty:
    "部门【{departmentName}】不能删除。请先移除管理员和司机后重试。",
  deleteFailedFleetNotEmpty:
    "车间【{fleetName}】不能删除。请先移除车间管理员和设备后重试。",
  deviceIsBusy: "系统繁忙，请稍后再试。",
  pleasePickNode: "请选择一个部门",
  failedToSaveDepartmentNameAlreadyExist: "保存失败，此部门名已占用。",
  failedToSaveUserOnlyOneOrganization:
    "保存失败，管理员{account}至少需管理一个部门或车间。",
  orgSearchPlaceholder: "部门名称，车间名称",
};
